"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.statusAsNumber = exports.isStatus = exports.addOrderDerivedOrderValues = exports.addOptionPrices = exports.getPriceFromSelectedOptions = exports.calcTotalCostOfOptions = exports.calcCostOfOption = exports.getSelectedOptionsFromOptionGroups = exports.addMemberPriceToMenuItem = exports.addMemberPricesToMenu = exports.getPriceString = exports.priceToPounds = exports.isMembershipInItems = exports.isItemAMembership = exports.getMembershipFromItems = exports.memberships = exports.deliveryPrices = void 0;
const lodash_1 = require("lodash");
const ramda_1 = require("ramda");
const redash_1 = require("@cnd/redash");
exports.deliveryPrices = {
    super: 409,
    ultra: 309,
    hiro: 199,
};
exports.memberships = {
    ultra: {
        shortname: 'ultra',
        discount: 25,
        index: 1,
        id: '430e751d-7113-4df1-a1f3-bdcc85949153',
        image: 'https://firebasestorage.googleapis.com/v0/b/indian-shack.appspot.com/o/menu%2F1677198046000__elephant_logo.png?alt=media',
        description: `Hiro Ultra members are claiming over £40/month back from their takeaway budget and saving on delivery.`,
        price: 0,
        hiroPrice: 0,
        superPrice: 0,
        ultraPrice: 0,
        invoicePrice: 709,
        billingCycle: `monthly`,
        name: 'Ultra',
        title: 'Ultra Club Membership',
        type: 'membership',
        freeOrderProbability: 0.5,
        color: '#08537d',
    },
    super: {
        color: '#FFFFFF',
        shortname: 'super',
        discount: 0,
        index: 0,
        billingCycle: `monthly`,
        hiroPrice: 0,
        superPrice: 0,
        description: '',
        ultraPrice: 0,
        price: 0,
        id: '430e751d-7113-4df1-a1f3-bdcc85949152',
        image: 'https://firebasestorage.googleapis.com/v0/b/indian-shack.appspot.com/o/menu%2F1677198046000__elephant_logo.png?alt=media',
        invoicePrice: 0,
        name: 'Super',
        title: 'Super Club Membership',
        type: 'membership',
        freeOrderProbability: 0,
    },
    hiro: {
        freeOrderProbability: 1,
        shortname: 'hiro',
        color: '#000000',
        discount: 50,
        index: 2,
        billingCycle: `monthly`,
        invoicePrice: 989,
        id: '430e751d-7113-4df1-a1f3-bdcc85949151',
        image: 'https://firebasestorage.googleapis.com/v0/b/indian-shack.appspot.com/o/menu%2F1677198046000__elephant_logo.png?alt=media',
        hiroPrice: 0,
        superPrice: 0,
        ultraPrice: 0,
        price: 0,
        description: `Hiro members are claiming over £60/month back from their takeaway budget and saving on delivery.`,
        name: 'Hiro',
        title: 'Hiro Club Membership',
        type: 'membership',
    },
};
const getMembershipFromItems = (items) => {
    let hiroInItems = (0, lodash_1.find)(items, ['id', exports.memberships.hiro['id']]);
    if (hiroInItems)
        return hiroInItems;
    let superInItems = (0, lodash_1.find)(items, ['id', exports.memberships.super['id']]);
    if (superInItems)
        return superInItems;
    let ultraInItems = (0, lodash_1.find)(items, ['id', exports.memberships.ultra['id']]);
    if (ultraInItems)
        return ultraInItems;
    return false;
};
exports.getMembershipFromItems = getMembershipFromItems;
const membershipIds = (0, ramda_1.map)((membership) => membership.id, (0, ramda_1.values)(exports.memberships));
const isItemAMembership = (item) => (0, lodash_1.includes)(membershipIds, item.id);
exports.isItemAMembership = isItemAMembership;
const isMembershipInItems = (items) => ((0, lodash_1.find)(items, (i) => (0, exports.isItemAMembership)(i)) ? true : false);
exports.isMembershipInItems = isMembershipInItems;
const priceToPounds = (price) => (price / 100).toFixed(2);
exports.priceToPounds = priceToPounds;
const getPriceString = (membership) => {
    let price = 'superPrice';
    if (membership === 'ultra')
        price = 'ultraPrice';
    if (membership === 'hiro')
        price = 'hiroPrice';
    return price;
};
exports.getPriceString = getPriceString;
const modifyPriceByLocation = (discount) => (price) => price * 2 * (1 - discount);
const addMemberPricesToMenu = (membership, priceModifier = 0.5) => (0, ramda_1.map)((0, exports.addMemberPriceToMenuItem)(membership, modifyPriceByLocation(priceModifier)));
exports.addMemberPricesToMenu = addMemberPricesToMenu;
exports.addMemberPriceToMenuItem = (0, ramda_1.curry)((membership, priceFormula, menuItem) => (0, ramda_1.mergeDeepRight)(menuItem, {
    price: priceFormula(menuItem[(0, exports.getPriceString)(membership)]),
}));
const addPrices = (items, membership, priceFormula) => (0, lodash_1.mapValues)(items, (item) => (0, exports.addMemberPriceToMenuItem)(membership, priceFormula, item));
const isSelectedOption = (option) => option.selected || option.quantity > 0;
const getSelectedOptionsFromOptionGroups = (item) => (0, ramda_1.filter)(isSelectedOption, (0, ramda_1.reduce)((options, group) => (0, ramda_1.union)(options, (0, ramda_1.values)(group.options)), [], (0, ramda_1.values)(item.optionGroups)));
exports.getSelectedOptionsFromOptionGroups = getSelectedOptionsFromOptionGroups;
const calcCostOfOption = (o) => {
    return (o.quantity ? o.cost * o.quantity : o.cost) || 0;
};
exports.calcCostOfOption = calcCostOfOption;
const calcTotalCostOfOptions = (item) => item.selectedOptions
    ? (0, ramda_1.reduce)((total, option) => total + (0, exports.calcCostOfOption)(option), 0, item.selectedOptions)
    : 0;
exports.calcTotalCostOfOptions = calcTotalCostOfOptions;
const getPriceFromSelectedOptions = (item, price = 'price') => item[price] - (!!item.freeOptionAmount ? item.freeOptionAmount : 0) + (0, exports.calcTotalCostOfOptions)(item);
exports.getPriceFromSelectedOptions = getPriceFromSelectedOptions;
const addOptionPrices = (items) => (0, lodash_1.mapValues)(items, (item) => (Object.assign(Object.assign({}, item), { price: (0, exports.getPriceFromSelectedOptions)(item, 'price'), superPriceWithOptions: (0, exports.getPriceFromSelectedOptions)(item, 'superPrice') })));
exports.addOptionPrices = addOptionPrices;
const DEFAULT_DISCOUNT = 1000;
const getDiscountFromCode = (discountCode) => {
    if (discountCode) {
        if (discountCode.discount)
            return discountCode.discount;
        return DEFAULT_DISCOUNT;
    }
    return 0;
};
const calcDiscountTotal = (0, ramda_1.curry)((discount, total) => {
    if (total - discount < 0)
        return 0;
    return total - discount;
});
const addOrderDerivedOrderValues = (order) => {
    const { items, membership, isCollection, discountCode, deliveryLocation } = order;
    const priceModifierByLocation = (deliveryLocation === null || deliveryLocation === void 0 ? void 0 : deliveryLocation['discount']) || 0.5;
    const itemsWithPrice = addPrices(items, membership, modifyPriceByLocation(priceModifierByLocation));
    const itemsWIthPricePlusOptionPrices = (0, exports.addOptionPrices)(itemsWithPrice);
    const deliveryLocationDeliveryPrice = typeof (deliveryLocation === null || deliveryLocation === void 0 ? void 0 : deliveryLocation['deliveryPrice']) === 'number'
        ? deliveryLocation['deliveryPrice']
        : exports.deliveryPrices[membership];
    const total = (0, redash_1.sumBy)('price', itemsWIthPricePlusOptionPrices);
    const totalSuper = (0, redash_1.sumBy)('superPriceWithOptions', itemsWIthPricePlusOptionPrices);
    const superDeliveryPrice = exports.deliveryPrices['super'];
    const discount = getDiscountFromCode(discountCode);
    const applyDiscount = calcDiscountTotal(discount);
    return (0, ramda_1.mergeDeepRight)(order, {
        items: itemsWIthPricePlusOptionPrices,
        itemsCount: (0, lodash_1.keys)(items).length,
        total: applyDiscount(total),
        totalSuper: applyDiscount(totalSuper),
        totalSuperIncludingDelivery: applyDiscount(totalSuper + (isCollection ? 0 : superDeliveryPrice)),
        totalIncludingDelivery: applyDiscount(total + (isCollection ? 0 : deliveryLocationDeliveryPrice)),
        deliveryPrice: isCollection ? 0 : deliveryLocationDeliveryPrice,
        superDeliveryPrice,
        discountApplied: discount,
    });
};
exports.addOrderDerivedOrderValues = addOrderDerivedOrderValues;
exports.isStatus = (0, ramda_1.curry)((o, status) => !!(0, lodash_1.find)(o.status, ['status', status]));
const statusAsNumber = (order) => {
    if ((0, exports.isStatus)(order, 'paid'))
        return 1;
    if ((0, exports.isStatus)(order, 'preparing'))
        return 2;
    if ((0, exports.isStatus)(order, 'ready_for_collection'))
        return 3;
    if ((0, exports.isStatus)(order, 'out_for_delivery'))
        return 4;
    if ((0, exports.isStatus)(order, 'delivered'))
        return 5;
    if ((0, exports.isStatus)(order, 'cancelled'))
        return 6;
    return 0;
};
exports.statusAsNumber = statusAsNumber;
//# sourceMappingURL=menu.js.map